<div>
  <app-widget-box>
    @if (completed()) {
    <div>
      <p>Transaction processed successfully.</p>
    </div>
    <div class="space-y-2">
      <div>
        <p class="text-green-600 text-center text-3xl">
          <i class="fa-solid fa-circle-check"></i>
        </p>
      </div>
      <div>
        <app-widget-data key="Message" value="{{result_message()}}" tooltip="This is the message you sent.">
        </app-widget-data>
      </div>
    </div>
    <div class="flex flex-row flex-wrap gap-1 justify-center">
      <app-widget-button (clicked)="view()" heading="View">
      </app-widget-button>
      <app-widget-button (clicked)="reset()" heading="Reset">
      </app-widget-button>
      <app-widget-button (clicked)="close()" heading="Close">
      </app-widget-button>
    </div>
    }
    @else if (processing()) {
    <div>
      <p>Sending transaction to blockchain.</p>
    </div>
    <div class="space-y-2">
      <div>
        <p class="text-green-600 text-center text-3xl">
          <i class="fa-solid fa-gear fa-spin"></i>
        </p>
      </div>
      <div>
        <app-widget-data key="Message" value="{{message_input()}}" tooltip="This is the message you are sending.">
        </app-widget-data>
      </div>
    </div>
    }
    @else {
    <div>
      <p>Join the discussion by sending a message.</p>
    </div>
    <div class="space-y-2">
      <div>
        <app-widget-textarea id="message_input" type="text" heading="Message" [(value)]="message_input"
          tooltip="This is the message you want to send.">
        </app-widget-textarea>
      </div>
    </div>
    <div>
      <app-widget-button (clicked)="send()" heading="Send Message">
      </app-widget-button>
    </div>
    }
  </app-widget-box>
</div>